import {
	DateAttribute,
	NumberAttribute,
	SelectAttribute,
	SemanticAttribute,
	TagAttribute,
	TextAttribute,
} from '../components/EditableAttribute';

import type {AttributeTemplateType} from '../schema';

/** Given an attribute type, will return the attribute component */
export const getAttributeComponent = (type: AttributeTemplateType) => {
	switch (type) {
		case 1:
		case 2: // Textarea
			return TextAttribute;
		case 3:
			return SelectAttribute;
		case 4:
			return DateAttribute;
		case 7:
			return NumberAttribute;
		case 12:
			return SemanticAttribute;
		case 13:
			return TagAttribute;
	}
};

export default getAttributeComponent;
